// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-selector {
  position: fixed;
  background-color: rgba(250, 248, 245, 0.9);
  border-radius: 12px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.06);
  width: 250px;
  z-index: 1000;
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
}

.map-selector-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(135, 134, 127, 0.25);
  cursor: grab;
  font-size: 14px;
  position: relative; /* Add this */
}

.map-selector-header:active {
  cursor: grabbing;
}

.map-selector-content {
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  font-size: 14px;
}

.map-selector select {
  width: calc(100% - 24px);
  padding: 16px;
  margin: 0 12px;
  border: 1px solid rgba(135, 134, 127, 0.25);
  border-radius: 8px;
  background-color: rgba(250, 248, 245, 0.9);
  font-family: "Crimson", serif;
  font-size: 14px;
}

.map-selector .select {
  width: 180px !important;
  font-size: 14px;
}

.map-selector .select .value {
  width: 180px !important;
  font-size: 14px;
}

.map-selector .select .value,
.map-selector .select .option {
  font-size: 14px !important;
  font-family: "Crimson", serif !important;
}

.map-selector .select span {
  font-size: 14px !important;
  font-family: "Crimson", serif !important;
}

/* Add/update close button styling */
.close-button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 4px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #454545;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Table/MapSelector.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,gDAAgD;EAChD,YAAY;EACZ,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kDAAkD;EAClD,YAAY;EACZ,eAAe;EACf,kBAAkB,EAAE,aAAa;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".map-selector {\n  position: fixed;\n  background-color: rgba(250, 248, 245, 0.9);\n  border-radius: 12px;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.06);\n  width: 250px;\n  z-index: 1000;\n  user-select: none;\n  font-size: 14px;\n}\n\n.map-selector-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(135, 134, 127, 0.25);\n  cursor: grab;\n  font-size: 14px;\n  position: relative; /* Add this */\n}\n\n.map-selector-header:active {\n  cursor: grabbing;\n}\n\n.map-selector-content {\n  padding: 16px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  font-size: 14px;\n}\n\n.map-selector select {\n  width: calc(100% - 24px);\n  padding: 16px;\n  margin: 0 12px;\n  border: 1px solid rgba(135, 134, 127, 0.25);\n  border-radius: 8px;\n  background-color: rgba(250, 248, 245, 0.9);\n  font-family: \"Crimson\", serif;\n  font-size: 14px;\n}\n\n.map-selector .select {\n  width: 180px !important;\n  font-size: 14px;\n}\n\n.map-selector .select .value {\n  width: 180px !important;\n  font-size: 14px;\n}\n\n.map-selector .select .value,\n.map-selector .select .option {\n  font-size: 14px !important;\n  font-family: \"Crimson\", serif !important;\n}\n\n.map-selector .select span {\n  font-size: 14px !important;\n  font-family: \"Crimson\", serif !important;\n}\n\n/* Add/update close button styling */\n.close-button {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 4px;\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #454545;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
